import { Injectable } from '@angular/core';

import { QuestionnaireFormComponent } from './questionnaire-form.component';
import { unsaveConfirm } from '../app.const';

@Injectable({
  providedIn: 'root'
})
export class QuestionnaireFormCanDeactivateGuard  {
  canDeactivate(component: QuestionnaireFormComponent): boolean {
    if (component.pageData.isUnsaved) {
      if (unsaveConfirm()) {
        return true;
      } else {
        return false;
      }
    }
    return true;

  }
}
